/* ---------------------------------------------------------------------------
 * leotude-video-resume.js  —  v1.0
 *
 * One job: if something pauses a gallery video, start it again.
 *
 * The markup already autoplays. product-thumbnail.liquid renders the clip
 * directly as <video autoplay muted loop playsinline> instead of hiding it
 * inside a <template>, and on desktop that is enough — it plays on its own
 * with no script at all. On a phone it does not, and the difference is not
 * the browser's autoplay policy: the file is a 6MB mp4 that opens and plays
 * in about a second when the URL is loaded directly, the video is the first
 * media, and nothing is blocking it.
 *
 * What differs on a phone is the gallery itself. Desktop renders the media
 * as a grid; mobile renders it as a slider, and Dawn's slider calls
 * pauseAllMedia() as it initialises and again on every slide change. That
 * function walks the page and pauses each <video> it finds — correct for
 * click-to-play media, wrong for a clip that is meant to loop quietly. So
 * the video does start, and is stopped a moment later.
 *
 * Rather than patch each of Dawn's call sites, this listens for the pause
 * and undoes it.
 *
 * Deliberately NOT included, because the earlier attempt at this file
 * carried all three and each one turned into the thing that broke it:
 *   - no IntersectionObserver, and nothing anywhere that calls pause()
 *   - no injecting: the <video> is already in the markup
 *   - no visibility test: off-screen slides are exactly the case that has
 *     to keep playing
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var GALLERY = 'media-gallery, .product__media-wrapper, .product__media-list';

  function watch(video) {
    if (video.dataset.ltResume === '1') return;
    video.dataset.ltResume = '1';

    /* The shopper's own pause has to stick. Without this the video would
       fight anyone who stops it with the controls on desktop. */
    video.addEventListener('click', function () {
      video.dataset.ltUserPaused = video.paused ? '1' : '0';
    });

    /* 400ms between attempts. A browser that is refusing playback outright
       (data saver, low power mode) rejects the promise immediately, and
       without this gate that rejection plus the pause event would spin. */
    var lastTry = 0;
    video.addEventListener('pause', function () {
      if (video.ended || video.dataset.ltUserPaused === '1') return;
      var now = Date.now();
      if (now - lastTry < 400) return;
      lastTry = now;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function scan() {
    var vids = document.querySelectorAll(GALLERY + ' video');
    for (var i = 0; i < vids.length; i++) {
      if (vids[i].closest('.product-media-modal')) continue; // modal stays manual
      watch(vids[i]);
    }
  }

  function boot() {
    scan();
    /* The gallery is replaced wholesale on variant change, so the elements
       watched above stop existing. */
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();